/**
 * Códigos de erro de CONEXÃO que atravessam back → front.
 *
 * O back lança `AppError(código, status)`; o front traduz por
 * `backendErrors.<código>` (toastError). Uma constante só, para os dois
 * lados e os testes falarem do mesmo nome — e para renomear quebrar em
 * compilação, não no toast do operador.
 *
 * Padrão: ERR_<DOMÍNIO>_<MOTIVO>.
 */
export const WHATSAPP_ERRORS = {
  /** 409 — conexão pertence a outro servidor (multi-servidor, #4418). */
  OTHER_SERVER: "ERR_WHATSAPP_OTHER_SERVER",
  /**
   * 409 — exclusão recusada: a conexão ainda tem tickets abertos/pendentes/de
   * grupo. Transfira para outra conexão antes (#4119). A contagem vem de
   * `whatsappTransferableTicketsContract`.
   */
  HAS_OPEN_TICKETS: "ERR_WHATSAPP_HAS_OPEN_TICKETS"
} as const;

export type WhatsappErrorCode = (typeof WHATSAPP_ERRORS)[keyof typeof WHATSAPP_ERRORS];
